export default {
  de: {
    back: 'Zurück',
    send: 'Senden',
  },
};
